import { render } from "./Topics.vue?vue&type=template&id=31be234c&scoped=true"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"

import "./Topics.vue?vue&type=style&index=0&id=31be234c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bp-kmiyajima\\Documents\\Projects\\noritz-protal\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31be234c"]])

export default __exports__